import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges, TemplateRef } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subscription } from 'rxjs';
import { enumTypeRupture } from 'src/app/core/enumerator/enumerator';
import { AuthService } from 'src/app/core/service/auth.service';
import { RestClientService } from 'src/app/core/service/rest-client.service';
import { UtilitiesService } from 'src/app/core/service/utilities.service';
@Component({
  selector: 'app-search-prestataire',
  templateUrl: './search-prestataire.component.html',
  styleUrls: ['./search-prestataire.component.scss']
})
export class SearchPrestataireComponent implements OnInit {

  //Declaration de la variable d'emission des valeurs
@Output() onSelectItem = new EventEmitter<any>();
@Input() cancelItemSelected : any;
@Input() defaultItem : any;
@Input() searchKey : any;

modalRef: BsModalRef;
isDisabled : boolean = false;
itemToSearch: any = {};
itemToSave: any = {};
listItem: Array<any> = [];
user : any = {};
busyGet: Subscription;
itemSelected : any = {};
canDisplay : boolean = false;
// searchKey:any

constructor(private authService: AuthService, private restClient: RestClientService,private modalService: BsModalService,private utilities: UtilitiesService) {
  this.user = this.authService.currentUserValue;
}

getItems() {

  this.canDisplay = true;

  let request = {
    user: this.user.id,
    search_key:this.searchKey,
    data: {
    },
    index: 0,
    size: 10
  }
    this.busyGet = this.restClient.post('prestataire/getByCriteria', request)
      // this.busyGet = this.restClient.post('pharmacieStockMedicament/getMedocsGrroup', request)
      .subscribe(
        res => {
          if (res && res['items']) {
            this.listItem = res['items'];
            this.listItem.map(li=>{
              console.info('listItem: ')
              this.addStyleToTyped(li)
          })

          }
          else {
            this.listItem = [];
          }
        },
        err => {
        }
      );
  
 
}




selectedItem(item : any){
  console.log('itemxxxxx: ',item)
  if(item){

    console.info(" this.itemSelected ",this.itemSelected);
    
    this.itemSelected = {...item};
    this.searchKey = this.itemSelected.libelle;
    
    // Brodcast de la valeur
    this.onSelectItem.emit(this.itemSelected);

    // On ferme le tableau de selection des patients
    this.canDisplay = false;


    
    // this.reinitValue()

  }else {
    if(!this.searchKey)  this.onSelectItem.emit(null);
  }
}


reinitValue() {
  this.itemSelected = {};
  this.canDisplay = false;
  this.selectedItem(null);
  this.searchKey = '';
}



ngOnInit(): void {
}


ngOnChanges(changes: SimpleChanges) {
  // this.searchKey='Hello world'
  console.info(" changes ",changes);
  
  if(changes['cancelItemSelected'] && changes['cancelItemSelected'].currentValue)
  {
    this.itemSelected = {};
    this.searchKey = null;
  }
  if(changes['searchKey'] && changes['searchKey'].currentValue)
  {
    this.itemSelected = {};
    this.searchKey = changes['searchKey'].currentValue;
    this.getItems()
  }
  if(changes['defaultItem'] && changes['defaultItem'].currentValue)
  {
    this.itemSelected = {};
    this.searchKey = changes['defaultItem'].currentValue;
    // this.getItems()
  }
}

addStyleToTyped(li: any) {
  let libelle = li.codification+' '+li.libelle
  let splited = libelle.split(this.searchKey.toUpperCase())
  console.info('splited: ',splited);
  //RENDRE DYNAMIQUE AU RANG N
  let toReturn = ''
  if(splited.length ==2)
      toReturn +=splited[0]+`<strong>`+this.searchKey.toUpperCase()+`</strong>`+splited[1]
  else{
      for(let i=0;i<splited.length;i++){
          if(splited[i+1])
              toReturn +=splited[i]+`<strong>`+this.searchKey.toUpperCase()+`</strong>`+splited[i+1]
          else
              toReturn +=splited[i]+`<strong>`+this.searchKey.toUpperCase()+`</strong>`
      }
  }
  console.info('toReturn: ',toReturn)
 
  return li.styled = toReturn
}



}
